import { render, staticRenderFns } from "./EditViewTermReportsSubjectRow.vue?vue&type=template&id=57967d2d"
import script from "./EditViewTermReportsSubjectRow.vue?vue&type=script&lang=js"
export * from "./EditViewTermReportsSubjectRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports